// fhirClient.js
import FHIR from "fhirclient";

let readyPromise = null;

export function getFhirClient() {
  if (!readyPromise) {
    readyPromise = FHIR.oauth2.ready();
  }
  return readyPromise;
}
